module.exports = __webpack_public_path__ + "jp.svg?2dcb030e6eaf682476b0bfe61c04021e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/jp.svg
// module id = 1040
// module chunks = 27